import {
  GET_ALL_STATES_SUCCESS,
  GET_ALL_DEALERS_SUCCESS,
  GET_ALL_DISTRICTS_SUCCESS,
  GET_ALL_TEHSILS_SUCCESS,
} from "../actions/dealer-action-types";
import uniqBy from "lodash/uniqBy";

const initialState = {
  allStates: [],
  allDealers: [],
  allDistricts: [],
  allTehsils: [],
};
export default function dealers(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_STATES_SUCCESS:
      return {
        ...state,
        allStates: uniqBy(payload, "State_Id"),
      };
    case GET_ALL_DISTRICTS_SUCCESS:
      return {
        ...state,
        allDistricts: uniqBy(payload, "District_Id"),
      };
    case GET_ALL_TEHSILS_SUCCESS:
      return {
        ...state,
        allTehsils: payload,
      };
    case GET_ALL_DEALERS_SUCCESS:
      return {
        ...state,
        allDealers: payload,
      };
    default: {
      return state;
    }
  }
}
